import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { fileDownload } from '../../helpers/helpers';
import SafeBtn from './SafeBtn';

const DownloadBtn = ({ id, text, tipText, url, className, width, loginIdToken, onClick }) => {
  const [loading, setLoading] = useState(false);
  const stopLoading = () => setLoading(false);

  const handleClick = () => {
    setLoading(true);
    if (onClick) {
      // Si hay un onClick personalizado, se ejecuta
      onClick(() => {
        fileDownload(url, loginIdToken, stopLoading);
      });
      stopLoading();
    } else {
      // De lo contrario, ejecuta el comportamiento por defecto
      setLoading(true);
      fileDownload(url, loginIdToken, stopLoading);
    }
    // stopLoading();

    const btn = document.getElementById(id);
    if (btn) {
      btn.blur();
    }
  };

  return (
    <>
      <SafeBtn
        loading={loading}
        id={id}
        className={className}
        style={{
          width,
          fontSize: '14px',
        }}
        disabled={!url && !onClick} // Deshabilitar si no hay URL ni función personalizada
        onClick={handleClick}
      >
        <FontAwesomeIcon icon={faDownload} />
        &nbsp;&nbsp;
        {text}
      </SafeBtn>
      <UncontrolledTooltip target={id}>
        {tipText}
      </UncontrolledTooltip>
    </>
  );
};

DownloadBtn.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  tipText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  loginIdToken: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  onClick: PropTypes.func, // Nuevo prop
};

DownloadBtn.defaultProps = {
  className: 'btn-orsan-primary',
  width: '170px',
  onClick: null, // Valor por defecto
};

const mapStateToProps = state => ({
  loginIdToken: state.login.id_token,
});

export default connect(mapStateToProps)(DownloadBtn);
